import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatCardModule, MatButtonModule, MatInputModule, MatFormFieldModule, MatSelectModule} from "@angular/material";
import {ValidadorModule} from "../shared/comun/components/validador/validador.module";
import {DialogModule} from "../shared/comun/components/dialog/dialog.module";
import {LoginComponent} from "./login.component";
import {EmpresaService} from "../core/services/empresa.service";
import {UsuarioService} from "../seguridad/services/usuario.service";
import {LoginRouting} from "./login.routing";

@NgModule({
    imports: [
        LoginRouting,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatCardModule,
        MatButtonModule,
        MatInputModule,
        MatFormFieldModule,
        MatSelectModule,
        ValidadorModule,
        DialogModule
    ],
    exports: [MatButtonModule, MatInputModule],
    declarations: [
        LoginComponent
    ],
    providers: [
        UsuarioService,
        EmpresaService
    ],
})

export class LoginModule {
}
